import React, { useEffect, useRef, useState } from "react";
import { Button, Input, Spin, Table, message } from "antd";
import { BiSolidDownArrow, BiSolidRightArrow } from "react-icons/bi";
import { MdPlayArrow } from "react-icons/md";
import { utils, writeFile } from "xlsx";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { FieldArray, Formik } from "formik";

import { asyncGetMapCoord } from "../../../redux/slices/relaySlice";
import MapComponent from "./mapComponent";
import MapComponentSecond from "./mapComponentsSecond";
import PreviewSheetModal from "./previewSheetModal";
import { asyncEditRoute } from "../../../redux/slices/routeSlice";

const { Column } = Table;

const RouteListing = ({
  selectedData,
  routes,
  formValue,
  expandedRowKey,
  setExpandedRowKey,
  isSearchRelayClicked,
  setIsSearchRelayClicked,
  vehicleFormRef,
}) => {
  const dispatch = useDispatch();
  const {
    loading,
    firstRouteData,
    secondRouteData,
    firstData,
    secondData,
    FirstExportData,
    SecondExportData,
    ErrorFirst,
    ErrorSecond,
    editLoading,
    routeData,
  } = useSelector((state) => ({
    loading: state.relay.getMapCoord.loading,
    firstRouteData: state.relay.getMapCoord.firstRouteData,
    secondRouteData: state.relay.getMapCoord.secondRouteData,
    firstData: state.relay.getMapCoord.firstData,
    secondData: state.relay.getMapCoord.secondData,
    FirstExportData: state.relay.getMapCoord.FirstExportData,
    SecondExportData: state.relay.getMapCoord.SecondExportData,
    ErrorFirst: state.relay.getMapCoord.ErrorFirst,
    ErrorSecond: state.relay.getMapCoord.ErrorSecond,
    editLoading: state.route.editRoute.loading,
    routeData: state.relay.getMapCoord.routeData,
  }));
  const formRef = useRef(null);
  const [coord, setCoord] = useState(null);
  const [allData, setAllData] = useState(null);
  const [buttonClicked, setButtonClicked] = useState({
    firstButton: true,
    secondButton: false,
  });

  const [messageApi, contextHolder] = message.useMessage();

  const [position, setPosition] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [selectedDataStatus, setSelectedDataStatus] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [loaderFirst, setLoaderFirst] = useState(false);
  const [loaderSecond, setLoaderSecond] = useState(false);
  const [isExpand, setIsExpand] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [plantCode, setPlantCode] = useState("")
  const templateDetails = {
    trucks: "0",
    trailers: "0",
  };

  const [initialValue, setInitialValue] = useState({
    trucksAndTrailers: [{ ...templateDetails }],
  });

  useEffect(() => {
    const initialSelectedData = Array(selectedData.length).fill(false);
    setSelectedDataStatus(initialSelectedData);
  }, [selectedData]);

  useEffect(() => {
    const data = buttonClicked.firstButton ? FirstExportData : SecondExportData;
    setPosition(data);
  }, [buttonClicked, FirstExportData, SecondExportData]);

  useEffect(() => {
    setCoord(firstRouteData);
    setAllData(firstData);
    setLoaderSecond(true);
    setTimeout(() => {
      setLoaderSecond(false);
    }, 10000);
  }, [firstData, firstRouteData]);

  useEffect(() => {
    if (buttonClicked.firstButton) {
      setCoord(firstRouteData);
      setAllData(firstData);
    } else {
      setCoord(secondRouteData);
      setAllData(secondData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonClicked]);

  useEffect(() => {
    let truckInitial = routeData.truck?.split(",") || [];
    let trailerInitial = routeData.trailer?.split(",") || [];
    let truckSecondInitial = routeData.truck_second?.split(",") || [];
    let trailerSecondInitial = routeData.trailer_second?.split(",") || [];
    setPlantCode(routeData.plantData?.code);
    
    let newInitialValue;

    if (buttonClicked.firstButton) {
      newInitialValue = {
        trucksAndTrailers: truckInitial?.map((truck, index) => ({
          trucks: truck || "0",
          trailers: trailerInitial[index] || "0",
        })),
      };
    } else {
      newInitialValue = {
        trucksAndTrailers: truckSecondInitial?.map((truck, index) => ({
          trucks: truck || "0",
          trailers: trailerSecondInitial[index] || "0",
        })),
      };
    }

    setInitialValue(newInitialValue);
    if (formRef.current) {
      formRef.current.setValues(newInitialValue);
    }
    setFormSubmitted(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    position,
    formSubmitted,
    routeData,
    buttonClicked.firstButton,
    buttonClicked.secondButton,
  ]);

  const handleSecondRouteClick = () => {
    setButtonClicked({
      firstButton: false,
      secondButton: true,
    });
    setSelectedDataStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[openIndex] = true;
      return newStatus;
    });
    setLoaderFirst(true);
    setTimeout(() => {
      setLoaderFirst(false);
    }, 10000);
  };

  const handleFirstRouteClick = () => {
    setButtonClicked({
      firstButton: true,
      secondButton: false,
    });
    setSelectedDataStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[openIndex] = false;
      return newStatus;
    });
    setLoaderSecond(true);
    setTimeout(() => {
      setLoaderSecond(false);
    }, 10000);
  };

  const handlePreviewSheet = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
    const clickedData = buttonClicked.firstButton
      ? FirstExportData
      : SecondExportData;

    let truckTrailerData = {};
    if (formRef.current) {
      truckTrailerData = formRef.current.values;
    }
    if (clickedData) {
      const exportData = clickedData?.map((itemData, index) => {
        let data = { ...itemData };

        if (truckTrailerData) {
          data = {
            ...itemData,
            ...truckTrailerData.trucksAndTrailers?.[index],
          };
        }

        const code = data?.type=== "Terminal" ? "SCG-"+data.TERMINAL :data?.type=== "Plant" ? data.plantCode: data?.type=== "ClosestTerminal" ? "SCG-"+data.TERMINAL :"";

        const object1 = {
          TERMINAL: data.TERMINAL || "",
          TERMINAL_CODE: code || "",
          RTE: data.RTE || "",
          "SPEC MILES": data["SPEC MILES"] || "",
          "YARD TIME": data["YARD TIME"] || "",
          "PUD TIME": data["PUD TIME"] || "",
          "ROUTE LEG": data["ROUTE LEG"] || "",
          "RTE TYPE": data["RTE TYPE"] || "",
          Relay: data.Relay || "",
          FREQ: data.FREQ || "",
          "DEPART DAY": data["DEPART DAY"] || "",
          "START TIME": data["START TIME"] || "",
          "ARRIVE DAY": data["ARRIVE DAY"] || "",
          "END TIME": data["END TIME"] || "",
          "TIME BETWEEN": data["TIME BETWEEN"] || "",
          STOPS: data.STOPS?.length - 1 || "",
          "D/H": data["D/H"] || "",
          "STARTING ARRIVAL": data["STARTING ARRIVAL"] || "",
          "STARTING DEPARTURE": data["STARTING DEPARTURE"] || "",
        };

        const object2 = data.STOPS.map((stop, index) => {
          let stopCode =""
          if(stop?.type_=== "Terminal" || stop?.type_=== "ClosestTerminal"){
            stopCode = "SCG-"+stop.name
          }else if(stop?.type_=== "Pilot" || stop?.type_=== "pilot"){
            let name = stop.name.split(",")
            if(name.length > 3){
              stopCode = name[1]
            }else{
              stopCode=name[0]
            }
          }else if(stop?.type_=== "Plant" || stop?.type_=== "plant"){
            stopCode = plantCode
          }else if(stop?.type_=== "Supplier" || stop?.type_=== "Supplier"){
            stopCode = stop.name
          }
          console.log("stopCode TYPE",stop?.type_);
          console.log("stopCode 240",stopCode);

          const object = {
            [`STOPS ${index + 1}`]: stop.address
              ? stop.address
              : stop.name || "",
            [`STOPS ${index + 1} CODE`]: stopCode || "",
            [`STOP ${index + 1} ARRIVAL`]: stop.ArriveDateTime
              ? stop.ArriveDateTime
              : stop.arriveDateTime || "",
            [`STOP ${index + 1} DEPARTURE`]: stop.departDateTimes
              ? stop.departDateTimes
              : stop.DepartDateTime
              ? stop.DepartDateTime
              : stop.departDateTime || "",
            [`STOP ${index + 1} MILES`]: stop.distance || "",
            [`STOP ${index + 1} TRANSIT TIME`]: stop.total_times
              ? stop.total_times
              : stop.total_time || "",
          };

          return object;
        });

        const object3 = {
          "END ARRIVAL": data["END ARRIVAL"] || "",
          "END DEPARTURE": data["END DEPARTURE"] || "",
          "END MILES": data["END MILES"] || "",
          "END TRANSIT TIME": data["END TRANSIT TIME"] || "",
          "Slip Seat": data["Slip Seat"] || "",
          "SlipSeat Route": data["Slip Seat Route"] || "",
          "Weekly Miles": data["Weekly Miles"] || "",
          "Weekly Stops": data["Weekly Stops"] || "",
          "Weekly Bid Hours": data["Weekly Bid Hours"] || "",
          "TOTAL LEG MILES": data["TOTAL LEG MILES"] || "",
          "TOTAL ROUTE MILES": data["TOTAL ROUTE MILES"] || "",
          DIFFERENCE: data.DIFFERENCE || "",
          OOR: data.OOR || "",
          "BID HRS": data["BID HRS"] || "",
          Trucks: data.trucks || "0",
          Trailers: data.trailers || "0",
          PERIOD_YR: data.PERIOD_YR || "",
          PERIOD: data.PERIOD || "",
        };

        return { object1, object2, object3 };
      });

      // setDynamicFormData(null);

      if (exportData) {
        const combinedData = [];
        exportData.forEach((data) => {
          const combinedStopObjects = data.object2.reduce((acc, stopObject) => {
            return {
              ...acc,
              ...stopObject,
            };
          }, {});
          combinedData.push({
            ...data.object1,
            ...combinedStopObjects,
            ...data.object3,
          });
        });
        setOpenModal(true);
        setModalData(combinedData);
      }
    }
  };

  const handleExpandRow = (record) => {
    const newRowKey = expandedRowKey === record.id ? null : record.id;
    setExpandedRowKey(newRowKey);
  };

  const expandedRowRender = (record) => {
    return (
      <>
        {record && (
          <>
            {loading || editLoading ? null : firstData?.length < 1 ? null : (
              <>
                <table className="expand_up_table">
                  <tbody>
                    <tr>
                      <td>
                        <strong>Customer</strong>
                      </td>
                      <td className="expand_table_data">{record?.customer}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Route</strong>
                      </td>
                      <td className="expand_table_data">{record?.puroute}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Route Date</strong>
                      </td>
                      <td className="expand_table_data">{record?.routeDate}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Spec Miles</strong>
                      </td>
                      <td className="expand_table_data">{record?.specMiles}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>RTE Type</strong>
                      </td>
                      <td className="expand_table_data">{record?.rteType}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Relay</strong>
                      </td>
                      <td className="expand_table_data">{record?.relay}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Frequency</strong>
                      </td>
                      <td className="expand_table_data">{record?.frequency}</td>
                    </tr>
                    {/* <tr>
                      <td>
                        <strong>Depart Day</strong>
                      </td>
                      <td className="expand_table_data">{record?.departDay}</td>
                    </tr> */}
                    <tr>
                      <td>
                        <strong>Period</strong>
                      </td>
                      <td className="expand_table_data">{record?.period}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Period Year</strong>
                      </td>
                      <td className="expand_table_data">
                        {record?.periodYear}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>PUD Time</strong>
                      </td>
                      <td className="expand_table_data">{record?.pudTime}</td>
                    </tr>
                  </tbody>
                </table>
                <table className="expand_down_table">
                  <thead>
                    <tr>
                      <th style={{ width: "20%" }}>Supplier</th>
                      <th style={{ width: "10%" }}>Code</th>
                      <th style={{ width: "15%" }}>Arrival Date</th>
                      <th style={{ width: "15%" }}>Arrival Time</th>
                      <th style={{ width: "15%" }}>Depart Date</th>
                      <th style={{ width: "15%" }}>Depart Time</th>
                      <th>Order</th>
                    </tr>
                  </thead>
                  {record?.suppliersData?.map((supplier, index) => {
                    return (
                      <tbody key={supplier?.id}>
                        <tr className="expand_row_table">
                          <td className="expand_row_field">
                            {supplier?.address}
                          </td>
                          <td className="expand_row_field">{supplier?.code}</td>
                          <td className="expand_row_field">
                            {supplier?.arriveDate}
                          </td>
                          <td className="expand_row_field">
                            {supplier?.arriveTime}
                          </td>
                          <td className="expand_row_field">
                            {supplier?.departDate}
                          </td>
                          <td className="expand_row_field">
                            {supplier?.departTime}
                          </td>

                          <td className="expand_row_field">{index + 1}</td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>

                <table
                  className="expand_down_table"
                  style={{ marginTop: "1rem" }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: "20%" }}>Plant Name</th>
                      <th style={{ width: "10%" }}>Code</th>
                      <th style={{ width: "15%" }}>Arrival Date</th>
                      <th style={{ width: "15%" }}>Arrival Time</th>
                      <th style={{ width: "15%" }}>Depart Date</th>
                      <th style={{ width: "15%" }}>Depart Time</th>
                      <th style={{ border: "none" }} />
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="expand_row_table ">
                      <td className="expand_row_field">
                        {record?.plantData?.plantName}
                      </td>
                      <td className="expand_row_field">
                        {record?.plantData?.code}
                      </td>
                      <td className="expand_row_field">
                        {record?.plantArrivalDate}
                      </td>
                      <td className="expand_row_field">
                        {record?.plantArrivalTime}
                      </td>
                      <td className="expand_row_field">
                        {record?.plantDepartDate}
                      </td>
                      <td className="expand_row_field">
                        {record?.plantDepartTime}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "60%" }}>
                    <div className="error_map">
                      {(buttonClicked.firstButton
                        ? ErrorFirst || []
                        : ErrorSecond || []
                      )?.map((error, index) => (
                        <div key={index} style={{ display: "flex" }}>
                          <div>
                            <MdPlayArrow />
                          </div>
                          <div>{error}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div style={{ width: "40%" }}>
                    {position.length > 0 && (
                      <Formik
                        innerRef={formRef}
                        initialValues={initialValue}
                        onSubmit={(values, { resetForm }) => {
                          setFormSubmitted(true);
                        }}
                      >
                        {({
                          handleChange,
                          handleSubmit,
                          setFieldValue,
                          values,
                        }) => (
                          <form onSubmit={handleSubmit}>
                            <FieldArray
                              name="trucksAndTrailers"
                              render={({ _ }) => {
                                return (
                                  <div>
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "30%" }}></div>
                                      <div
                                        style={{
                                          width: "70%",
                                          padding: "0.7rem 0 0 0",
                                          marginRight: "2.6rem",
                                        }}
                                      >
                                        <table
                                          style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th style={{ width: "40%" }}></th>
                                              <th style={{ width: "30%" }}>
                                                Trucks
                                              </th>
                                              <th style={{ width: "30%" }}>
                                                Trailers
                                              </th>
                                            </tr>
                                          </thead>
                                          {position?.map((_, index) => (
                                            <tbody key={index}>
                                              <tr>
                                                <th>{`Route Leg ${
                                                  index + 1 || 0
                                                }`}</th>
                                                <th>
                                                  <Input
                                                    id={`trucksAndTrailers.${index}.trucks`}
                                                    name={`trucksAndTrailers.${index}.trucks`}
                                                    value={
                                                      values.trucksAndTrailers[
                                                        index
                                                      ]?.trucks !== undefined
                                                        ? values
                                                            .trucksAndTrailers[
                                                            index
                                                          ]?.trucks
                                                        : "0"
                                                    }
                                                    onChange={handleChange}
                                                    onKeyDown={(e) => {
                                                      const isNumeric =
                                                        /^[0-9]*$/;
                                                      const isBackspace =
                                                        e.key === "Backspace";
                                                      const isDot =
                                                        e.key === ".";
                                                      if (
                                                        !(
                                                          isNumeric.test(
                                                            e.key
                                                          ) ||
                                                          isBackspace ||
                                                          isDot
                                                        )
                                                      ) {
                                                        e.preventDefault();
                                                      }
                                                    }}
                                                  />
                                                </th>
                                                <th>
                                                  <Input
                                                    id={`trucksAndTrailers.${index}.trailers`}
                                                    name={`trucksAndTrailers.${index}.trailers`}
                                                    value={
                                                      values.trucksAndTrailers[
                                                        index
                                                      ]?.trailers !== undefined
                                                        ? values
                                                            .trucksAndTrailers[
                                                            index
                                                          ]?.trailers
                                                        : "0"
                                                    }
                                                    onChange={handleChange}
                                                    onKeyDown={(e) => {
                                                      const isNumeric =
                                                        /^[0-9]*$/;
                                                      const isBackspace =
                                                        e.key === "Backspace";
                                                      const isDot =
                                                        e.key === ".";
                                                      if (
                                                        !(
                                                          isNumeric.test(
                                                            e.key
                                                          ) ||
                                                          isBackspace ||
                                                          isDot
                                                        )
                                                      ) {
                                                        e.preventDefault();
                                                      }
                                                    }}
                                                  />
                                                </th>
                                              </tr>
                                            </tbody>
                                          ))}
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }}
                            ></FieldArray>
                          </form>
                        )}
                      </Formik>
                    )}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        margin: "1rem 2rem 0 0",
                      }}
                    >
                      <div className="map_button_div">
                        <Button
                          className={`map_button ${
                            buttonClicked.firstButton
                              ? "active_map"
                              : "not_active_map"
                          }`}
                          onClick={handleFirstRouteClick}
                          disabled={buttonClicked.firstButton}
                          loading={loaderFirst}
                        >
                          Get First Route
                        </Button>
                        <Button
                          className={`map_button ${
                            buttonClicked.secondButton
                              ? "active_map"
                              : "not_active_map"
                          }`}
                          onClick={handleSecondRouteClick}
                          disabled={buttonClicked.secondButton}
                          loading={loaderSecond}
                        >
                          Get Second Route
                        </Button>
                      </div>
                      <div className="map_button_preview">
                        <div className="error_map">
                          {/* {buttonClicked.firstButton
                          ? ErrorFirst || null
                          : ErrorSecond || null}
                        {Error ? `* ${Error}` : null} */}
                        </div>
                        <Button
                          className="map_button"
                          onClick={handlePreviewSheet}
                        >
                          Preview Sheet
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="map_div">
                  {buttonClicked.firstButton ? (
                    <MapComponent response={coord} data={allData} />
                  ) : (
                    <MapComponentSecond response={coord} data={allData} />
                  )}
                </div>
              </>
            )}
          </>
        )}
      </>
    );
  };

  const footerElement = () => {
    return (
      <div className="relay_table_footer">
        <Button onClick={handleExportAllEdit}>Export All</Button>
      </div>
    );
  };

  const handleExportAllEdit = () => {
    let truckTrailerData = {};
    if (formRef.current) {
      formRef.current.handleSubmit();
    }

    if (formRef.current) {
      truckTrailerData = formRef.current.values;
    }

    let formattedData;

    if (buttonClicked.firstButton) {
      formattedData = {
        truck: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trucks)
          ?.join(","),
        trailer: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trailers)
          ?.join(","),
      };
    } else {
      formattedData = {
        truck_second: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trucks)
          ?.join(","),
        trailer_second: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trailers)
          ?.join(","),
      };
    }

    if (formattedData) {
      dispatch(asyncEditRoute({ id: expandedRowKey, ...formattedData })).then(
        (res) => {
          if (res.payload) {
            handleExportAll();
          }
        }
      );
    }
  };

  const handleExportAll = async () => {
    try {
      const allData = [];
      const truckDataArray = [];
      const trailerDataArray = [];
      for (let i = 0; i < selectedData.length; i++) {
        const item = selectedData[i];
        const res = await dispatch(
          asyncGetMapCoord({ id: item.id, ...formValue })
        );

        if (res.payload?.data) {
          const data = selectedDataStatus[i]
            ? res.payload.data?.exportSecond
            : res.payload.data?.export;

          const firstTruckData =
            res.payload.data?.resultRoute?.truck?.split(",") || [];
          const firstTrailerData =
            res.payload.data?.resultRoute?.trailer?.split(",") || [];
          const secondTruckData =
            res.payload.data?.resultRoute?.truck_second?.split(",") || [];
          const secondTrailerData =
            res.payload.data?.resultRoute?.trailer_second?.split(",") || [];

          if (selectedDataStatus[i]) {
            truckDataArray.push(secondTruckData);
            trailerDataArray.push(secondTrailerData);
          } else {
            truckDataArray.push(firstTruckData);
            trailerDataArray.push(firstTrailerData);
          }

          allData.push(data);
        } else {
          messageApi.open({
            type: "error",
            content: "Failed to fetch data for ID: " + item.id,
          });
        }
      }

      const mergedArray = allData?.reduce((acc, curr) => acc.concat(curr), []);
      const truckData = truckDataArray?.reduce(
        (acc, curr) => acc.concat(curr),
        []
      );

      const trailerData = trailerDataArray?.reduce(
        (acc, curr) => acc.concat(curr),
        []
      );

      const maxStops = Math.max(
        ...mergedArray.map((itemData) => itemData.STOPS?.length)
      );

      if (mergedArray) {
        const exportData = mergedArray?.map((itemData, index) => {
          const data = {
            ...itemData,
            truck: truckData[index] || 0,
            trailer: trailerData[index] || 0,
          };

          const code = data?.type=== "Terminal" ? "SCG-"+data.TERMINAL :data?.type=== "Plant" ? data.plantCode: data?.type=== "ClosestTerminal" ? "SCG-"+data.TERMINAL :"";

          const object1 = {
            TERMINAL: data.TERMINAL || "",
            TERMINAL_CODE: code || "",
            Customer: data.Customer || "",
            RTE: data.RTE || "",
            "SPEC MILES": data["SPEC MILES"] || "",
            "YARD TIME": data["YARD TIME"] || "",
            "PUD TIME": data["PUD TIME"] || "",
            "ROUTE LEG": data["ROUTE LEG"] || "",
            "RTE TYPE": data["RTE TYPE"] || "",
            Relay: data.Relay || "",
            FREQ: data.FREQ || "",
            "DEPART DAY": data["DEPART DAY"] || "",
            "START TIME": data["START TIME"] || "",
            "ARRIVE DAY": data["ARRIVE DAY"] || "",
            "END TIME": data["END TIME"] || "",
            "TIME BETWEEN": data["TIME BETWEEN"] || "",
            STOPS: data.STOPS?.length - 1 || "",
            "D/H": data["D/H"] || "",
            "STARTING ARRIVAL": data["STARTING ARRIVAL"] || "",
            "STARTING DEPARTURE": data["STARTING DEPARTURE"] || "",
          };

          const stopObjects = {};
          for (let j = 0; j < maxStops; j++) {
            stopObjects[`STOP ${j + 1} ADDRESS`] = "";
            stopObjects[`STOP ${j + 1} CODE`] = "";
            stopObjects[`STOP ${j + 1} ARRIVAL`] = "";
            stopObjects[`STOP ${j + 1} DEPARTURE`] = "";
            stopObjects[`STOP ${j + 1} MILES`] = "";
            stopObjects[`STOP ${j + 1} TRANSIT TIME`] = "";
          }
          const object2 = data.STOPS.map((stop, stopIndex) => {
            let stopCode =""
            if(stop?.type_=== "Terminal" || stop?.type_=== "ClosestTerminal"){
              stopCode = "SCG-"+stop.name
            }else if(stop?.type_=== "Pilot" || stop?.type_=== "pilot"){
              let name = stop.name.split(",")
              if(name.length > 3){
                stopCode = name[1]
              }else{
                stopCode=name[0]
              }
            }else if(stop?.type_=== "Plant" || stop?.type_=== "plant"){
              stopCode = plantCode
            }else if(stop?.type_=== "Supplier" || stop?.type_=== "Supplier"){
              stopCode = stop.name
            }
            console.log("stopCode TYPE",stop?.type_);

            console.log("stopCode 851",stopCode);
            stopObjects[`STOP ${stopIndex + 1} ADDRESS`] = stop.address
              ? stop.address
              : stop.name || "";
            stopObjects[`STOP ${stopIndex + 1} CODE`] = stopCode || "";
            stopObjects[`STOP ${stopIndex + 1} ARRIVAL`] = stop.ArriveDateTime
              ? stop.ArriveDateTime
              : stop.arriveDateTime || "";
            stopObjects[`STOP ${stopIndex + 1} DEPARTURE`] = stop.DepartDateTime
              ? stop.DepartDateTime
              : stop.departDateTime || "";
            stopObjects[`STOP ${stopIndex + 1} MILES`] = stop.distance || "";
            stopObjects[`STOP ${stopIndex + 1} TRANSIT TIME`] = stop.total_times
              ? stop.total_times
              : stop.total_time || "";

            return stopObjects;
          });

          const object3 = {
            "END ARRIVAL": data["END ARRIVAL"] || "",
            "END DEPARTURE": data["END DEPARTURE"] || "",
            "END MILES": data["END MILES"] || "",
            "END TRANSIT TIME": data["END TRANSIT TIME"] || "",
            "Slip Seat": data["Slip Seat"] || "",
            "SlipSeat Route": data["Slip Seat Route"] || "",
            "Weekly Miles": data["Weekly Miles"] || "",
            "Weekly Stops": data["Weekly Stops"] || "",
            "Weekly Bid Hours": data["Weekly Bid Hours"] || "",
            "TOTAL LEG MILES": data["TOTAL LEG MILES"] || "",
            "TOTAL ROUTE MILES": data["TOTAL ROUTE MILES"] || "",
            DIFFERENCE: data.DIFFERENCE || "",
            OOR: data.OOR || "",
            "BID HRS": data["BID HRS"] || "",
            Trucks: data.truck || "0",
            Trailers: data.trailer || "0",
            PERIOD_YR: data.PERIOD_YR || "",
            PERIOD: data.PERIOD || "",
          };

          return { object1, object2, object3 };
        });

        if (exportData) {
          const combinedData = [];
          exportData.forEach((data) => {
            const combinedStopObjects = data.object2.reduce(
              (acc, stopObject) => {
                return {
                  ...acc,
                  ...stopObject,
                };
              },
              {}
            );
            combinedData.push({
              ...data.object1,
              ...combinedStopObjects,
              ...data.object3,
            });
          });
          const ws = utils.json_to_sheet(combinedData);
          const wb = utils.book_new();
          utils.book_append_sheet(wb, ws, "Export Data");

          writeFile(wb, "all_export_data.xlsx");
        }
      }
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Something went wrong while exporting all data.",
      });
    }
  };

  const formatData = (resData, truckData, trailerData) => {
    const exportData = resData?.map((itemData, index) => {
      const data = {
        ...itemData,
        truck: truckData[index] || 0,
        trailer: trailerData[index] || 0,
      };

      const code = data?.type=== "Terminal" ? "SCG-"+data.TERMINAL :data?.type=== "Plant" ? data.plantCode: data?.type=== "ClosestTerminal" ? "SCG-"+data.TERMINAL :"";

      const object1 = {
        TERMINAL: data.TERMINAL || "",
        TERMINAL_CODE: code || "",
        Customer: data.Customer || "",
        RTE: data.RTE || "",
        "SPEC MILES": data["SPEC MILES"] || "",
        "YARD TIME": data["YARD TIME"] || "",
        "PUD TIME": data["PUD TIME"] || "",
        "ROUTE LEG": data["ROUTE LEG"] || "",
        "RTE TYPE": data["RTE TYPE"] || "",
        Relay: data.Relay || "",
        FREQ: data.FREQ || "",
        "DEPART DAY": data["DEPART DAY"] || "",
        "START TIME": data["START TIME"] || "",
        "ARRIVE DAY": data["ARRIVE DAY"] || "",
        "END TIME": data["END TIME"] || "",
        "TIME BETWEEN": data["TIME BETWEEN"] || "",
        STOPS: data.STOPS?.length - 1 || "",
        "D/H": data["D/H"] || "",
        "STARTING ARRIVAL": data["STARTING ARRIVAL"] || "",
        "STARTING DEPARTURE": data["STARTING DEPARTURE"] || "",
      };

      
      const object2 = data.STOPS.map((stop, index) => {
        // const stopCode = stop?.type=== "Terminal" ? "SCG-"+stop.name :stop?.type=== "Plant" ? stop.name: stop?.type=== "ClosestTerminal" ? "SCG-"+stop.name :stop?.type=== "Supplier" ? "SCG-"+stop.name :"";
        let stopCode =""
        if(stop?.type_=== "Terminal" || stop?.type_=== "ClosestTerminal"){
          stopCode = "SCG-"+stop.name
        }else if(stop?.type_=== "Pilot" || stop?.type_=== "pilot"){
          let name = stop.name.split(",")
          if(name.length > 3){
            stopCode = name[1]
          }else{
            stopCode=name[0]
          }
        }else if(stop?.type_=== "Plant" || stop?.type_=== "plant"){
          stopCode = plantCode
        }else if(stop?.type_=== "Supplier" || stop?.type_=== "Supplier"){
          stopCode = stop.name
        }
        console.log("stopCode TYPE",stop?.type_);

        console.log("stopCode 972",stopCode);

        const object = {
          [`STOPS ${index + 1}`]: stop.address ? stop.address : stop.name || "",
          [`STOPS ${index + 1} CODE`]: stopCode || "",
          [`STOP ${index + 1} ARRIVAL`]: stop.ArriveDateTime
            ? stop.ArriveDateTime
            : stop.arriveDateTime || "",
          [`STOP ${index + 1} DEPARTURE`]: stop.departDateTimes
            ? stop.departDateTimes
            : stop.DepartDateTime
            ? stop.DepartDateTime
            : stop.departDateTime || "",
          [`STOP ${index + 1} MILES`]: stop.distance || "",
          [`STOP ${index + 1} TRANSIT TIME`]: stop.total_times
            ? stop.total_times
            : stop.total_time || "",
        };

        return object;
      });

      const object3 = {
        "END ARRIVAL": data["END ARRIVAL"] || "",
        "END DEPARTURE": data["END DEPARTURE"] || "",
        "END MILES": data["END MILES"] || "",
        "END TRANSIT TIME": data["END TRANSIT TIME"] || "",
        "Slip Seat": data["Slip Seat"] || "",
        "SlipSeat Route": data["Slip Seat Route"] || "",
        "Weekly Miles": data["Weekly Miles"] || "",
        "Weekly Stops": data["Weekly Stops"] || "",
        "Weekly Bid Hours": data["Weekly Bid Hours"] || "",
        "TOTAL LEG MILES": data["TOTAL LEG MILES"] || "",
        "TOTAL ROUTE MILES": data["TOTAL ROUTE MILES"] || "",
        DIFFERENCE: data.DIFFERENCE || "",
        OOR: data.OOR || "",
        "BID HRS": data["BID HRS"] || "",
        Trucks: data.truck || "0",
        Trailers: data.trailer || "0",
        PERIOD_YR: data.PERIOD_YR || "",
        PERIOD: data.PERIOD || "",
      };

      return { object1, object2, object3 };
    });

    if (exportData) {
      const combinedData = [];
      exportData.forEach((data) => {
        const combinedStopObjects = data.object2.reduce((acc, stopObject) => {
          return {
            ...acc,
            ...stopObject,
          };
        }, {});
        combinedData.push({
          ...data.object1,
          ...combinedStopObjects,
          ...data.object3,
        });
      });

      const ws = utils.json_to_sheet(combinedData);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Export Data");

      writeFile(wb, `${combinedData[0].RTE.replace(/ /g, "_")}.xlsx`);
    }
  };

  const handleExportExcel = (id) => {
    let truckTrailerData = {};
    if (formRef.current) {
      formRef.current.handleSubmit();
    }

    if (formRef.current) {
      truckTrailerData = formRef.current.values;
    }

    let formattedData;

    if (buttonClicked.firstButton) {
      formattedData = {
        truck: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trucks)
          ?.join(","),
        trailer: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trailers)
          ?.join(","),
      };
    } else {
      formattedData = {
        truck_second: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trucks)
          ?.join(","),
        trailer_second: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trailers)
          ?.join(","),
      };
    }

    if (formattedData) {
      dispatch(asyncEditRoute({ id: expandedRowKey, ...formattedData })).then(
        (res) => {
          if (res.payload) {
            // if (expandedRowKey === id) {
            //   const clickedData = buttonClicked.firstButton
            //     ? FirstExportData
            //     : SecondExportData;
            //   formatData(clickedData);
            // } else {
            dispatch(asyncGetMapCoord({ id: id, ...formValue })).then((res) => {
              if (res.payload?.data) {
                const firstRouteData = res.payload.data?.export;
                const secondRouteData = res.payload.data?.exportSecond;
                const resData = buttonClicked.firstButton
                  ? firstRouteData
                  : secondRouteData;

                const firstTruckData =
                  res.payload.data?.resultRoute?.truck?.split(",") || [];
                const firstTrailerData =
                  res.payload.data?.resultRoute?.trailer?.split(",") || [];
                const secondTruckData =
                  res.payload.data?.resultRoute?.truck_second?.split(",") || [];
                const secondTrailerData =
                  res.payload.data?.resultRoute?.trailer_second?.split(",") ||
                  [];

                let truckData = [];
                let trailerData = [];
                if (buttonClicked.firstButton) {
                  truckData = firstTruckData;
                  trailerData = firstTrailerData;
                } else {
                  truckData = secondTruckData;
                  trailerData = secondTrailerData;
                }

                formatData(resData, truckData, trailerData);
              } else {
                messageApi.open({
                  type: "error",
                  content: "Something want wrong!.",
                });
              }
            });
          }
        }
        // }
      );
    }
  };

  const editHandle = () => {
    let truckTrailerData = {};
    if (formRef.current) {
      formRef.current.handleSubmit();
    }

    if (formRef.current) {
      truckTrailerData = formRef.current.values;
    }

    let formattedData;

    if (buttonClicked.firstButton) {
      formattedData = {
        truck: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trucks)
          ?.join(","),
        trailer: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trailers)
          ?.join(","),
      };
    } else {
      formattedData = {
        truck_second: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trucks)
          ?.join(","),
        trailer_second: truckTrailerData.trucksAndTrailers
          ?.map((item) => item.trailers)
          ?.join(","),
      };
    }

    if (formattedData) {
      dispatch(asyncEditRoute({ id: expandedRowKey, ...formattedData }));
    }
  };

  useEffect(() => {
    if (isSearchRelayClicked) {
      if (expandedRowKey !== null) editHandle();
    }
    setIsSearchRelayClicked(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearchRelayClicked]);

  return (
    <div>
      {contextHolder}
      <div style={{ position: "relative" }}>
        {(loading || editLoading) && (
          <div
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              backdropFilter: "blur(1px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: "9999",
            }}
          >
            <Spin size="large" />
            {/* <Spin
              indicator={<LoadingOutlined style={{ fontSize: 36 }} spin />}
            /> */}
          </div>
        )}
      </div>
      <div>
        {selectedData?.length > 0 && (
          <div style={{ margin: "3rem 0 2rem 0" }}>
            <Table
              dataSource={selectedData}
              bordered
              size="small"
              pagination={false}
              footer={footerElement}
              rowKey={(record) => record?.id}
              expandable={{
                expandedRowRender,
                expandedRowKeys: expandedRowKey ? [expandedRowKey] : [],
                onExpand: (_, record) => {
                  const index = selectedData.findIndex(
                    (item) => item.id === record.id
                  );
                  handleExpandRow(record);
                  setOpenIndex(index);
                },
                expandIcon: ({ expanded, onExpand, record }) =>
                  expanded ? (
                    <BiSolidDownArrow
                      size={20}
                      className="view_icon expanded"
                      onClick={(e) => {
                        onExpand(record, e);
                        editHandle();
                      }}
                    />
                  ) : (
                    <BiSolidRightArrow
                      size={20}
                      className="view_icon"
                      style={{ cursor: isExpand ? "not-allowed" : "pointer" }}
                      onClick={(e) => {
                        if (vehicleFormRef.current) {
                          vehicleFormRef.current.handleSubmit();
                        }

                        if (!isExpand) {
                          onExpand(record, e);
                          dispatch(
                            asyncGetMapCoord({
                              id: record?.id,
                              ...vehicleFormRef.current.values,
                            })
                          ).then((res) => {
                            if (res.payload?.status === 200) {
                              setIsExpand(true);
                              setTimeout(() => {
                                setIsExpand(false);
                              }, 10000);
                            } else {
                              messageApi.open({
                                type: "error",
                                content:
                                  res.payload?.message ||
                                  "Something went wrong",
                              });
                            }
                          });
                          setButtonClicked({
                            firstButton: true,
                            secondButton: false,
                          });
                        }
                      }}
                    />
                  ),
              }}
            >
              <Column
                title="Customer"
                key="customer"
                render={(record) => record?.customer}
              />
              <Column
                title="Puroute"
                key="puroute"
                render={(record) => record?.puroute}
              />
              <Column
                title="Route Date"
                key="routeDate"
                render={(record) => record?.routeDate}
              />

              <Column
                title="Spec Miles"
                key="specMiles"
                render={(record) => record?.specMiles}
              />

              <Column
                title="Action"
                key="action"
                width="12%"
                align="center"
                render={(record) => (
                  <div className="relay_icon">
                    {/* <Tooltip title="View">
                    <i
                      onClick={() => {
                        setOpenModal(true);
                        setModalData({
                          mode: "view",
                          data: rowData,
                        });
                      }}
                    >
                      <BiSolidDownArrow size={20} className="edit_icon" />
                    </i>
                  </Tooltip> */}
                    <Button onClick={() => handleExportExcel(record?.id)}>
                      Export
                    </Button>
                  </div>
                )}
              />
            </Table>
          </div>
        )}
      </div>
      {openModal && (
        <PreviewSheetModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalData={modalData}
        />
      )}
    </div>
  );
};

export default RouteListing;
